import React from 'react';
import { Flex, Text } from '../../../vanilla'
import { InfoIcon } from '../../../components/icons'

const PreBookNonRefundableCallout = () => (
  <Flex gap="8px" alignItems='center' style={{ backgroundColor: '#FABB0540', padding: '8px', borderRadius: '4px' }}>
    <InfoIcon style={{ color: '#4A4B4D', fill: '#4A4B4D'}} />
    <Text variant="text1" lineHeight={'none'} color='gray800'>Pre-Book Delivery charges are non-refundable</Text>
  </Flex>
);

export default PreBookNonRefundableCallout;
